//SMOOTH STICKY HEADER
$(window).scroll(function () {
    var sticky = $("#SearchDrawer"),
        scroll = $(window).scrollTop();

    if (scroll >= 40) {
        sticky.addClass("fixed-header");
    } else {
        sticky.removeClass("fixed-header");
    }
});

$(document).ready(function () {
    //TAB FAQS
    $(".faqpage .accordion").each(function () {
        $(this).click(function () {
            var dataId = $(this).attr("id");

            console.log("data-id - " + dataId);
            $(".faqpage .container[data-id='" + dataId + "']").toggleClass("active-faq");
            $(this).toggleClass("active-faq");
        });
    });
    // ============
    $(".js-open-search").click(function (e) {
        e.preventDefault();
        let formSearch = $(".layout-logo__center form[role='search']");
        if (formSearch.hasClass("show-input")) {
            if ($(window).width() <= 768) {
                formSearch.removeClass("show-input");
            } else {
                formSearch.submit();
            }
        } else {
            formSearch.addClass("show-input");
        }
    });
    // =============
    function aa() {
        if ($(window).width() <= 768) {
            try {
                $(".authentication").slick({
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                });
            } catch {}
        } else {
            try {
                $(".authentication").slick("unslick");
            } catch {}
        }
    }

    aa();
    $(window).resize(function () {
        aa();
    });
    // =============
    if ($(".header-sticky")) {
        setTimeout(function () {
            let nodeHeight = $(".header-sticky").height();
            $(".authentication").css("margin-top", nodeHeight + "px");
            window.addEventListener("resize", () => {
                nodeHeight = $(".header-sticky").height();
                $(".authentication").css("margin-top", nodeHeight + "px");
            });
        }, 500);
    }
    // =================
    $(".js-slide-announcement").slick({
        slidesToShow: 1,
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
    });

    // ajax add to cart
    fetch("/cart.js")
        .then((res) => res.json())
        .then((resData) => {
            theme.ajaxCart = resData;
        });

    document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
        form.addEventListener("submit", function (e) {
            e.preventDefault();
            let id_pro = parseInt(form.elements["id"].value);
            let qty = form.elements["quantity"] ? parseInt(form.elements["quantity"].value) : 1;
            let formData = {
                items: [
                    {
                        id: id_pro,
                        quantity: qty,
                    },
                ],
            };
            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            })
                .then((response) => response.json())
                .then((data) => {
                    fetch("/cart.js")
                        .then((res) => res.json())
                        .then((resData) => {
                            cartDrawer(resData);
                            if(form.classList.contains('product-form-product-template')) {
                                $("#cartDrawer").addClass("open");
                                $("body").css({
                                    overflow: "hidden",
                                });
                            }
                        });
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        });
    });

    // toggle cart drawer
    $(".site-header__cart").click(function (e) {
        e.preventDefault();
        $("#cartDrawer").addClass("open");
        $("body").css({
            overflow: "hidden",
        });
    });
    $(".js-close-cart").click(function (e) {
        e.preventDefault();
        $("#cartDrawer").removeClass("open");
        $("body").css({
            overflow: "",
        });
    });
    $("body").on("click", ".item-remove", function (e) {
        e.preventDefault();
        let par = $(this).parents(".cart-item");
        let idItem = parseInt(par.data("id"));
        let lineIndex;
        theme.ajaxCart.items.forEach((i, index) => {
            if (i.id == idItem) lineIndex = index;
        });
        let data = JSON.stringify({
            line: lineIndex + 1,
            quantity: 0,
        });
        changeItem(data);
    });
    $("body").on("click", ".js-item-btn", function (e) {
        e.preventDefault();
        let par = $(this).parents(".cart-item");
        let idItem = parseInt(par.data("id"));
        let qtyItem = parseInt(par.find($(".item-qty")).text());
        let lineIndex, newQty;
        theme.ajaxCart.items.forEach((i, index) => {
            if (i.id == idItem) lineIndex = index;
        });
        if ($(this).data("type") == "plus" && $(this).hasClass("item-plus")) {
            newQty = qtyItem + 1;
        } else if ($(this).data("type") == "minus" && $(this).hasClass("item-minus")) {
            newQty = qtyItem - 1;
        }
        let data = JSON.stringify({
            line: lineIndex + 1,
            quantity: newQty,
        });
        changeItem(data);
    });
    $('[data-faq]').each(function(e){
        let _this = $(this);
        _this.find($('.question-faq')).click(function(a){
            _this.toggleClass('open');
            _this.find($('.answer-faq')).slideToggle(200, function(){
                $(this).toggleClass('opened');
            });
        });
    });
});

function cartDrawer(dataCart) {
    theme.ajaxCart = dataCart;
    let cartDrawer = $("#cartDrawer");
    $("#js-cart-count").text(dataCart.item_count);
    $("#js-orginal-price").text(theme.Currency.formatMoney(dataCart.original_total_price));
    $("#jjs-discount").text(theme.Currency.formatMoney(dataCart.total_discount));
    $("#js-total").text(theme.Currency.formatMoney(dataCart.total_price));
    if (dataCart.item_count <= 0) {
        cartDrawer.find($(".cart-main")).addClass("cart-no-item");
        $("#CartCount").addClass("hide");
    } else {
        $("#CartCount").removeClass("hide");
        cartDrawer.find($(".cart-main")).removeClass("cart-no-item");
        let main = cartDrawer.find($(".js-render-items"));
        main.html("");
        dataCart.items.forEach(function (item) {
            main.append(cartItem(item));
        });
    }
}

function changeItem(data) {
    fetch("/cart/change.js", {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: data,
    })
        .then((res) => res.json())
        .then((resData) => {
            if (resData.status == 404 || resData.status == 422) {
                alert(resData.message + "\n" + resData.description);
                return;
            }
            cartDrawer(resData);
        });
}
function cartItem(item) {
    return `
    <div class="cart-item" data-id="${item.id}">
        <div class="item-image">
            <a href="${item.url}">
                <img src="${theme.Images.getSizedImageUrl(item.image, "200x200")}" alt="${escape(item.title)}" />
            </a>
        </div>
        <div class="item-container">
            <div class="row">
                <h4 title="${item.product_title}">
                    <a href="${item.url}">${item.product_title}</a>
                </h4>
                <div class="item-remove"><i class="fa fa-trash" aria-hidden="true"></i></div>
            </div>
            ${item.variant_title ? `<div class="row">${item.variant_title}</div> ` : ``}
            <div class="row">
                <div class="item-action">
                    <div class="item-minus js-item-btn" data-type="minus"></div>
                    <div class="item-qty">${item.quantity}</div>
                    <div class="item-plus js-item-btn" data-type="plus"></div>
                </div>
                <div class="item-price">
                    <div>${theme.Currency.formatMoney(item.final_line_price)}</div>
                </div>
            </div>
        </div>
    </div>`;
}
